import Axios from 'axios';
import { getPathName, getApiHash, getApiToken } from './helper';

export const obtenerCondicionesIVA = async () => {
    const params = {
        hash: await getApiHash(),
        provincia: ""
    }
    const headers = {
        'content-type': 'application/json',
        "Authorization": 'Bearer ' + await getApiToken()
    }
    return await Axios.post(await getPathName() + "/getcondicionivajson", params,
        {
            headers: headers
        }).then(function (response) {
            return response.data.api_data.map( function(cond:any) {
                return {
                    value: cond.codigo,
                    label: cond.descripcion
                }
            })
        }).catch(function (error) {
            return error;
        });
}